import { createSlice } from "@reduxjs/toolkit"
import { profileApi } from "./profileApi"

import { type RootState } from "../../app/apis"
import { ProfileUser } from "./models/MeUser"

type ProfileState = {
  profile: ProfileUser | null
}

const initialState: ProfileState = {
  profile: null,
}

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload
    },
    clearProfile: (state) => {
      state.profile = null
    },
  },
  extraReducers: (builder) => {
    // @ts-ignore: Type inference for RTK Query matcher
    builder.addMatcher(
      profileApi.endpoints.getProfile.matchFulfilled,
      (state, { payload }) => {
        state.profile = payload
      },
    )
  },
})

export const profileActions = profileSlice.actions

export const selectProfile = (state: RootState) => state.profile.profile

export const selectIsReady = (state: RootState) =>
  state.profile.profile?.user?.userId !== undefined
